import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from 'src/app/models';
import { ApiService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class ApiOzonProductListService {

  constructor(
    private api: ApiService
  ) { }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.api.post('ozon/productList', params, 'private', 'integrationOzon');
  }

  /**
    * 
    * @param id 
    * @returns 
    */
  getInfo(id: string): Observable<Res> {

    return this.api.get('ozon/getProductInfo', id, 'private', 'integrationOzon');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  save(params: any): Observable<Res> {

    return this.api.post('savePriceList', params, 'private', 'integrationKaspi');
  }
}
